<i class="ri-user-line" (click)="account()"></i>
@if(!mobileView){
    <app-login-modal #loginModal></app-login-modal>
}
